<template>
  <div class="wrapper">
    <div class="main">
      <div class="main--inner">
        <Header />
        <Banner />
        <div class="container" :class="{ mobile: isMobile }">
          <div class="cartoon">
            <div class="xiaojian">
              <div class="xiaojian--inner">
                <img
                  class="animate__animated animate__infinite wave_animate"
                  :src="require(`@/assets/img/main/xiaojian.png`)"
                  alt=""
                />
              </div>
            </div>
            <div class="xiaoku">
              <div class="cartoon--inner">
                <img
                  class="animate__animated animate__infinite wave_animate"
                  :src="require(`@/assets/img/main/xiaoku.png`)"
                  alt=""
                />
              </div>
            </div>
            <div class="xiaomei">
              <div class="cartoon--inner">
                <img
                  class="animate__animated animate__infinite wave_animate"
                  :src="require(`@/assets/img/main/xiaomei.png`)"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="guide--page">
            <div class="ts">
              <img
                :src="require(`@/assets/img/main/img-title-ts.png`)"
                alt=""
              />
            </div>
            <div class="guide--page--inner">
              <div class="guide--title">
                <div class="guide--title-text">
                  CIFST-第三届"三只松鼠杯"
                </div>
              </div>
              <div class="guide--title">
                <div class="guide--title-text">
                  休闲食品创新大赛复赛入围名单
                </div>
              </div>
              <div class="no--after">
                （排名不分先后）
              </div>
              <div class="intermediary--table">
                <div class="table--inner">
                  <div class="table">
                    <div class="table--head">
                      <div class="table-col table-col1">
                        <div class="table--head--box">
                          <i class="head-icon icon-orderby"></i>
                          <div class="head-text">
                            序号
                          </div>
                        </div>
                      </div>
                      <div class="table-col table-col2">
                        <div class="table--head--box">
                          <i class="head-icon icon-creative"></i>
                          <div class="head-text">
                            创意名称
                          </div>
                        </div>
                      </div>
                      <div class="table-col table-col3">
                        <div class="table--head--box">
                          <i class="head-icon icon-school"></i>
                          <div class="head-text">
                            所属高校
                          </div>
                        </div>
                      </div>
                      <div class="table-col table-col4">
                        <div class="table--head--box">
                          <i class="head-icon icon-member"></i>
                          <div class="head-text">
                            团队成员
                          </div>
                        </div>
                      </div>
                      <div class="table-col table-col5">
                        <div class="table--head--box">
                          <i class="head-icon icon-teacher"></i>
                          <div class="head-text">
                            指导老师
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table--body">
                      <div
                        class="list--item"
                        :key="index"
                        v-for="(item, index) in list"
                      >
                        <div class="table-col table-col1">
                          <div class="order-number">
                            <img
                              :key="subIndex"
                              v-for="(sub, subIndex) in String(
                                item.orderBy
                              ).split('')"
                              :src="
                                require('@/assets/img/number/' +
                                  (index % 2 === 0 ? 'grey-number/' : '') +
                                  sub +
                                  '.png')
                              "
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="table-col table-col2">
                          {{ item.name }}
                        </div>
                        <div class="table-col table-col3">
                          {{ item.school }}
                        </div>
                        <div class="table-col table-col4">
                          {{ item.member }}
                        </div>
                        <div class="table-col table-col5">
                          {{ item.teacher }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../Header";
import Banner from "../Banner";

export default {
  name: "index",
  components: { Header, Banner },
  data() {
    return {
      list: [
        {
          orderBy: 1,
          name: "相思",
          school: "南昌大学",
          member: "邱如虹、韩玉英、戴娜娜、刘岸鹭、丁帅",
          teacher: "吴志华、熊春红"
        },
        {
          orderBy: 2,
          name: "流心冰皮酥",
          school: "南昌大学",
          member: "郭世贤、陈勇、魏欣、甘佳熙",
          teacher: "刘军平、邹立强"
        },
        {
          orderBy: 3,
          name: "松松鱼骨",
          school: "南昌大学",
          member: "赵阳、代安琪、鄂芊竹、陈思懿、赖玥",
          teacher: "黄赣辉"
        },
        {
          orderBy: 4,
          name: "KA! 果然脆",
          school: "南昌大学",
          member: "马慧莹、李嘉昊、张亿、钟宛名、匡仁洽",
          teacher: "孙 永"
        },
        {
          orderBy: 5,
          name: "果然芯冻",
          school: "南昌大学",
          member: "程兰岚、王鑫、刘思悦、赵依依、吴天宇",
          teacher: "吴建永、邹立强"
        },
        {
          orderBy: 6,
          name: "牛郎芝女",
          school: "南昌大学",
          member: "齐文菲、黄莹、宋清誉、胡茜、王娜",
          teacher: "黄赣辉"
        },
        {
          orderBy: 7,
          name: "“植”上谈饼",
          school: "南昌大学",
          member: "冯一鸣、张婉卿、于小涵、肖思思、王彤彤",
          teacher: "罗舜菁"
        },
        {
          orderBy: 8,
          name: "“葛园”三结义",
          school: "南昌大学",
          member: "赖怡辉、陈乐奕、崔焱珧、徐苑瑞、赵梓航",
          teacher: "罗舜菁"
        },
        {
          orderBy: 9,
          name: "Color乳酸菌手撕面包 ",
          school: "江南大学",
          member: "储传奇、李露露、岳晨博、郭丹颖、周颖",
          teacher: "翟齐啸"
        },
        {
          orderBy: 10,
          name: "真猪裹茶——坚果夹心猪肉脯",
          school: "江南大学",
          member: "杨忠煜、郑歆璇、王敏、刘心怡、王斐",
          teacher: "金征宇、王周平"
        },
        {
          orderBy: 11,
          name: "猜丁壳",
          school: "江南大学",
          member: "王越、闵锐、解雯、肖瑶、彭水易",
          teacher: "洪 雁、张文斌"
        },
        {
          orderBy: 12,
          name: "薯你不可",
          school: "江南大学",
          member: "张睿逸、李晟阳、宋芷仪、邱奕娴、肖越月",
          teacher: "范大明"
        },
        {
          orderBy: 13,
          name: "嗑骨蜜",
          school: "江南大学",
          member: "汤玺乐、钱千一、邹晶如、陈浩然、高思敏",
          teacher: "焦爱权"
        },
        {
          orderBy: 14,
          name: "加油！秋小葵",
          school: "江南大学",
          member: "汪琳涔、徐晨昱、吴添奕、吴慧、杨适萌",
          teacher: "王 莉"
        },
        {
          orderBy: 15,
          name: "“蒜”你狠·三只松鼠蒜香豌豆",
          school: "中国农业大学",
          member: "卢晓红、吕雯欣、林彤、单子依、侯力天",
          teacher: "刘 萍"
        },
        {
          orderBy: 16,
          name: "鱼·玩",
          school: "中国农业大学",
          member: "刘雨文、庞晓旭、胡嘉欣、石稳、杨璐",
          teacher: "洪惠、徐洁仪"
        },
        {
          orderBy: 17,
          name: "素素肉肉牛肉粒",
          school: "中国农业大学",
          member: "戴可欣、刘思淼、黄天卓、杨欣雨、谢宇菲",
          teacher: "季俊夫"
        },
        {
          orderBy: 18,
          name: "清轻花语·无蔗糖全麦吐司",
          school: "中国农业大学",
          member: "李菲、余京京、蔡振鑫、王一川、韦柳伊",
          teacher: "刘 萍"
        },
        {
          orderBy: 19,
          name: "⼀周 mini 轻食——元气肉丸",
          school: "中国农业大学",
          member: "角霖、林紫城、卫晓慧、赵佳月、葛阳",
          teacher: "季俊夫"
        },
        {
          orderBy: 20,
          name: "“轻松”低糖低脂肉松饼",
          school: "中国农业大学",
          member: "隆浩渊、赵馨宁、邢一琳、衣祉霖、罗毓琦",
          teacher: "张 昊"
        },
        {
          orderBy: 21,
          name: "“燕麦吱吱球”营养代餐食品",
          school: "浙江工商大学",
          member: "陈心怡、曹婕、商晶晶、黄香、赫兰静",
          teacher: "宦 城"
        },
        {
          orderBy: 22,
          name: "酸奶“裹”果——果味坚果夹心酸奶球",
          school: "浙江工商大学",
          member: "谭博洋、林苗苗、胡豪犇",
          teacher: "房 升"
        },
        {
          orderBy: 23,
          name: "“椰宝包”椰蓉膳食纤维手撕面包",
          school: "浙江工商大学",
          member: "黄兴欣、沈诗珂、任少天、金丹丽",
          teacher: "顾振宇"
        },
        {
          orderBy: 24,
          name: "米真棒",
          school: "浙江工商大学",
          member: "徐枫、杨润龙、王子馨",
          teacher: "曲道峰"
        },
        {
          orderBy: 25,
          name: "花语吐司面包",
          school: "安徽工程大学",
          member: "司齐齐、吴云龙、陆阳、杨瑞兰、刘永圆",
          teacher: "丁佳红、何祥玲、朱秀灵"
        },
        {
          orderBy: 26,
          name: "脆花鸡",
          school: "安徽工程大学",
          member: "张瑞涛、张恒、吴强劲、何方圆、瞿畅瑜",
          teacher: "谢丹、钟莉娟"
        },
        {
          orderBy: 27,
          name: "山药拍拍乐",
          school: "安徽工程大学",
          member: "陈小雨、张悦、丁宁馨、毛佳晴、徐王燕",
          teacher: "王顺民、何祥玲、谢丹"
        },
        {
          orderBy: 28,
          name: "坚果烤芙",
          school: "安徽工程大学",
          member: "倪张辰宇、陈善豪、侯淑贤、高越",
          teacher: "薛正莲、王顺民"
        },
        {
          orderBy: 29,
          name: "魔薯“敲”酸——盲盒版",
          school: "大连工业大学",
          member: "王汀滢、于永佳、张子杰、李泓茜、李阳",
          teacher: "艾春青 "
        },
        {
          orderBy: 30,
          name: "觅立方",
          school: "大连工业大学",
          member: "杜林聪、朱苏园、刘佳宜、焦诗怡、曹易航",
          teacher: "崔玉娜"
        },
        {
          orderBy: 31,
          name: "“衣”颗坚果",
          school: "合肥工业大学",
          member: "李名扬、江鑫杰、俞锡婷、陈茜歌、胡林慧",
          teacher: "马 飞"
        },
        {
          orderBy: 32,
          name: "“茶有此仁”",
          school: "合肥工业大学",
          member: "詹朋阳、陈宇明、王阳、董渊、陈奇权",
          teacher: "马意龙"
        },
        {
          orderBy: 33,
          name: "保胃站—陈皮护胃饼干",
          school: "华中农业大学",
          member: "丁当、周恬艺﹑曾维佳﹑冯小芹﹑胡松子",
          teacher: "李 艳"
        },
        {
          orderBy: 34,
          name: "“就酱”",
          school: "华中农业大学",
          member: "罗璐、张书会、盛丽、莫翠园、务俊月",
          teacher: "马爱民"
        },
        {
          orderBy: 35,
          name: "蛋糕心酥酥",
          school: "华中农业大学",
          member: "陈雯欣、邓志昌、刘佳玮、朱丽娟、范玉蓉",
          teacher: "李 斌"
        },
        {
          orderBy: 36,
          name: "“鼠”你棒",
          school: "哈尔滨商业大学",
          member: "倪晓钰、武震宇、王昱净、金思齐、李圳",
          teacher: "遇世友"
        },
        {
          orderBy: 37,
          name: "巧克力果干脆片",
          school: "哈尔滨商业大学",
          member: "王子轩、邢童林、张建新、朱鹏宇、刘琳琳",
          teacher: "边鑫、杨 杨"
        },
        {
          orderBy: 38,
          name: "坚果の多巴胺",
          school: "哈尔滨商业大学",
          member: "任祉梦、王一冰、洪晔、关馨、赵雅恬",
          teacher: "陈凤莲"
        },
        {
          orderBy: 39,
          name: "爆浆奶枣",
          school: "陕西科技大学",
          member: "韩佳蓉、武娇、吴博妍、李驰、熊芳芳",
          teacher: "王虎玄"
        },
        {
          orderBy: 40,
          name: "吃不胖的肉肉",
          school: "陕西科技大学",
          member: "闵婉妮、单锦瑞、石珑华、吕琪琪、解传炜",
          teacher: "李道明、韩万友"
        },
        {
          orderBy: 41,
          name: "椒鱿",
          school: "南京师范大学",
          member: "赵家昂、华宜家、李思思、蒋佩容",
          teacher: "罗海波"
        },
        {
          orderBy: 42,
          name: "KUA！牛肉",
          school: "澳门科技大学",
          member: "陈婧雯、栾秋凝、林雪莹、袁蔚檬、韩尚杰",
          teacher: "钟 恬"
        },
        {
          orderBy: 43,
          name: "乳酸菌全麦发酵面包",
          school: "澳门科技大学",
          member: "陈婧雯、栾秋凝、林雪莹、袁蔚檬、韩尚杰",
          teacher: "钟 恬"
        },
        {
          orderBy: 44,
          name: "一路“鱿”你-紫苏蜜汁鱿鱿棒",
          school: "福州大学",
          member: "吴栩璐、张宇凤、翁文、林桂红、揭志凌",
          teacher: "张 雯"
        },
        {
          orderBy: 45,
          name: "茶power——元气茶味虾仁",
          school: "福州大学",
          member: "王瀚东、郑昕怡、杨海钰、王贵鹏、王诚欣",
          teacher: "张 雯"
        },
        {
          orderBy: 46,
          name: "桂妃醉酒",
          school: "渤海大学",
          member: "李佳怡、郭晓倩、何璟源、赵楠、徐明熙",
          teacher: "李 君"
        },
        {
          orderBy: 47,
          name: "食否食否——束脩红果",
          school: "渤海大学",
          member: "齐妍、孙宇轩、余悦、张晨晨、纪美",
          teacher: "李 君"
        },
        {
          orderBy: 48,
          name: "轻糖寡水•“桃”你喜欢",
          school: "江苏科技大学",
          member: "代雯、刘稼鑫、丁可欣、李伟、贾艾雪",
          teacher: "叶 华、赵 敏"
        },
        {
          orderBy: 49,
          name: "β-胡萝卜素鸡尾酒风味音乐麦bar",
          school: "仲恺农业工程学院",
          member: "庄姗姗、陈泳琪、神子俊、张水澜、吴丽英",
          teacher: "刘袆帆、王琴、肖更生"
        },
        {
          orderBy: 50,
          name: "一颗甜豆",
          school: "华东理工大学",
          member: "张睿毅、林泽旭、贾正阳、吕茵、唐佳陶",
          teacher: "杜 磊"
        },
        {
          orderBy: 51,
          name: "津豆糖",
          school: "天津科技大学",
          member: "秦东泽、杨潇、刘玉洁、李旭",
          teacher: "李文钊"
        },
        {
          orderBy: 52,
          name: "坚果疙瘩",
          school: "天津科技大学",
          member: "苗天晴、张景林、刘若琳、南月雯、古丽妮尕尔、陈佳",
          teacher: "郭庆彬"
        },
        {
          orderBy: 53,
          name: "简爱乳——“榛”好“核” ",
          school: "南京财经大学",
          member: "胡恒、杨家琦、黎恩玲、王淑晴",
          teacher: "丁 睑"
        },
        {
          orderBy: 54,
          name: "有你才甜——无糖猪肉脯",
          school: "西北农林科技大学",
          member: "许淼杰、张宇、汪天明、武天亮、王俊兰",
          teacher: "陈 琳"
        },
        {
          orderBy: 55,
          name: "酒酿坚果脆",
          school: "西北农林科技大学",
          member: "段江凯、李苏陈、鹿艺萌、李欢",
          teacher: "王敏、刘芳"
        },
        {
          orderBy: 56,
          name: "芙了你了",
          school: "四川农业大学",
          member: "陈梦平、何雨、周宗惠、熊尘、谭志文",
          teacher: "张 清"
        },
        {
          orderBy: 57,
          name: "高蛋白高纤维生酮吐司",
          school: "沈阳农业大学",
          member: "陈曦睿、周笑盈、李洋、宋梓琪、李秀俊",
          teacher: "杨 强"
        },
        {
          orderBy: 58,
          name: "低甜度红茶特色风味翻砂卤蛋产品开发",
          school: "山西农业大学",
          member: "武阿苗、赵超凡、李诗丹、景凯鑫、杨欣然",
          teacher: "于智慧、白锦霞"
        },
        {
          orderBy: 59,
          name: "营养早餐饼干",
          school: "中南林业科技大学",
          member: "胡深德、沈俊利、肖婧怡、张子依、陈子昕 ",
          teacher: "陆 俊"
        },
        {
          orderBy: 60,
          name: "雪莲乳酸奶酪",
          school: "南京农业大学",
          member: "肖倩、张文文",
          teacher: "邵士昌、邵春妍"
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    }
  },
  methods: {}
};
</script>

<style scoped lang="less">
@import "../style.less";
@import "./dyn.less";
</style>
